// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { hasSubmitSucceeded } from 'redux-form';
import connectWithFormName from 'app/hoc/withFormName';
import {makeTheme, withTheme, withStyles} from '@phg/stilo-toolbox/components/ThemeProvider';
import Theme from '@phg/stilo-toolbox/v2/theme';
import {Button, Link} from '@phg/stilo-toolbox/v2/component';
import {l} from 'app/Translate';


import makeStyle from './emailConfirmComponentStyles';

class EmailConfirm extends React.Component<*> {
    resendEmail = () => {
        const { apiUrl, user } = this.props;

        if (user && user.user_id) {
            axios.patch(
                `https://${apiUrl}v3/partner/user`, 
                {emailAddress: user.email_address},
                {
                    auth: {
                        username: user.application_api_key,
                        password: user.user_api_key
                    },
                    headers: { Authorization: 'Basic ' + btoa(`${user.application_api_key}:${user.user_api_key}`) }
                }
            );
        }
    };
    
    render() {
        const { registrationCompleted, signUpCompleteUrl, classes } = this.props;
       
        if (registrationCompleted) {
            sessionStorage.removeItem('merchantId');

            return (
                <div className={classes.Content}>
                    <div className={classes.Logo} />
                    <span className={classes.Title} >{l('Verification email sent!')}</span>
                    <span className={classes.Text}>
                        {/* eslint-disable-next-line max-len */}
                        {l('A verification email has been sent to the email address linked to this account. Click the link in the email to complete sign up.')}&nbsp;
                        <Link
                            onClick={this.resendEmail}
                        >
                            {l('Resend verification email')}
                        </Link>.
                    </span>
                    <Button.Main
                        className={classes.Button}
                        onClick={() => window.open(signUpCompleteUrl)}
                    >
                        {l('Log in to')}{' '}Partnerize
                    </Button.Main>
                </div>
            );
        }
        
        return false;
    }
}

EmailConfirm.propTypes = {
    signUpCompleteUrl: PropTypes.string,
    registrationCompleted: PropTypes.bool,
    classes: {
        Content: PropTypes.string,
        Title: PropTypes.string,
        Logo: PropTypes.string,
        Text: PropTypes.string,
        Button: PropTypes.string,
    },
    user: PropTypes.object
};

const ThemedEmailConfirm = withTheme(
    makeTheme(Theme)
)(withStyles(makeStyle)(EmailConfirm));


const ConnectedEmailConfirm = connectWithFormName(
    (state, { formName }) => ({
        registrationCompleted: hasSubmitSucceeded(formName)(state),
        user: state.user.user
    })
)(ThemedEmailConfirm);

export {
    ConnectedEmailConfirm as default, ThemedEmailConfirm
};
